var exports = {
  "k": "xdde3148b--285e95--container",
  "l": "xdde3148b--285e95--phone",
};

module.exports = exports;
